export default __webpack_public_path__ + "static/media/image-12.bf22ba33.webp";